export default {
	firebaseApiKey: "AIzaSyAo9xKvTnSiahrXg4QV0tsyb2GrWbSZyUQ"
};
